import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ISiralamaItem {
  sira: number;
  isim: string;
  deger: number;
  renk?: string;
}

@Component({
  selector: 'widget-siralama-listesi',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="siralama-kapsayici">
      @for (item of veriler(); track item.sira; let i = $index) {
        <div class="siralama-satir" [class.zebra]="i % 2 === 1">
          <span class="sira-badge" [style.background]="item.renk || varsayilanRenk(i)">{{ item.sira }}</span>
          <span class="siralama-isim">{{ item.isim }}</span>
          <div class="bar-kapsayici">
            <div class="bar-dolgu"
                 [style.width.%]="barGenislik(item.deger)"
                 [style.background]="item.renk || varsayilanRenk(i)">
            </div>
          </div>
          <span class="siralama-deger">{{ item.deger }}</span>
        </div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .siralama-kapsayici { display: flex; flex-direction: column; }
    .siralama-satir {
      display: flex; align-items: center; gap: 8px;
      padding: 6px 12px; transition: background 0.15s;
    }
    .siralama-satir.zebra { background: var(--py-hover, rgba(0,0,0,0.02)); }
    .sira-badge {
      width: 22px; height: 22px; border-radius: 6px;
      display: flex; align-items: center; justify-content: center;
      font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0;
    }
    .siralama-isim {
      font-size: 13px; font-weight: 500; min-width: 60px; flex-shrink: 0;
      color: var(--py-metin, #262626);
      overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 120px;
    }
    .bar-kapsayici {
      flex: 1; height: 8px; border-radius: 4px;
      background: var(--py-hover, rgba(0,0,0,0.06)); overflow: hidden;
    }
    .bar-dolgu {
      height: 100%; border-radius: 4px;
      transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .siralama-deger {
      font-size: 13px; font-weight: 600; min-width: 36px; text-align: right;
      color: var(--py-metin, #262626);
    }
  `],
})
export class SiralamaListesiComponent {
  veriler = input<ISiralamaItem[]>([]);

  private maxDeger = computed(() => {
    const v = this.veriler();
    return v.length ? Math.max(...v.map(i => i.deger)) : 1;
  });

  barGenislik(deger: number): number {
    const max = this.maxDeger();
    return max > 0 ? (deger / max) * 100 : 0;
  }

  varsayilanRenk(index: number): string {
    const renkler = ['#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#eb2f96', '#fa8c16'];
    return renkler[index % renkler.length];
  }
}
